/*eslint-disable*/
import React from "react"

// reactstrap components
import { Container } from "reactstrap"

// core components

function IndexHeader() {
  const [iconPills, setIconPills] = React.useState(1)
  let pageHeader = React.createRef()

  React.useEffect(() => {
    if (window.innerWidth > 991) {
      const updateScroll = () => {
        let windowScrollTop = window.pageYOffset / 3;
        pageHeader.current.style.transform =
          "translate3d(0," + windowScrollTop + "px,0)";
      };
      window.addEventListener("scroll", updateScroll);
      return function cleanup() {
        window.removeEventListener("scroll", updateScroll);
      };
    }
  });

  return (
    <>
      <div className="page-header clear-filter" filter-color="blue" id="index-header">
        <div
          className="page-header-image"
          style={{
            backgroundImage:
              "url(" + require("assets/img/star-background.jpg").default + ")",
          }}
          ref={pageHeader}
        ></div>
        
        <Container>
          <div className="content-center brand">
{/*             <img
              alt="logo"
              className="n-logo"
              src={require("assets/img/logo-nuit.png").default}
            ></img> */}
            <br></br>
            <br></br>
            <br></br>
            <h1 className="h1-seo">Bienvenue sur le site de Nuit Insa</h1>
            <h2>Le Samedi 5 Mars 2022</h2>
            <h3>A la Cité des Congrès de Valenciennes</h3>
          </div>


        </Container>
      </div>
    </>
  );
}

export default IndexHeader;
